import React from "react";
import { useTranslation } from "react-i18next";
import VelavuButton from "../../elements/velavu-button";
import VelavuNotice from "../../elements/velavu-notice/velavu-notice";
import * as styles from "./component-save-bar.module.scss";
import { classArr } from "../../helper/style-helper";

interface ComponentSaveBarProps {
	style?: React.CSSProperties;
	className?: string;

	disabled?: boolean;
	onClick?: VoidFunction;
	secondaryAction?: React.ReactNode;

	result: boolean | null;
	labelOK: string;
	labelError: string;
}

export default function ComponentSaveBar(props: ComponentSaveBarProps) {
	const { t } = useTranslation();
	return (
		<div
			className={classArr(styles.footer, props.className)}
			style={props.style}
		>
			<div className={styles.actions}>
				<VelavuButton
					label={t("common.save_changes")}
					disabled={props.disabled}
					onClick={props.onClick}
				/>
				{props.secondaryAction}
			</div>
			{props.result === true && (
				<VelavuNotice className={styles.notice} type="confirm">
					{props.labelOK}
				</VelavuNotice>
			)}
			{props.result === false && (
				<VelavuNotice className={styles.notice} type="error">
					{props.labelError}
				</VelavuNotice>
			)}
		</div>
	);
}
